export const customerPasswordRegExp = /(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!#$%&*?@^_-])(?!.*\s).{8,}/;
export const invalidPasswordMsg = 'The password must be at least 8 characters long and must contain at least: 1 uppercase or lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)';
